import type { FormikProps } from "formik";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const useLocalizedValidationErrorMessages = (form: FormikProps<any>) => {
  const { i18n } = useTranslation();

  const { errors, setFieldTouched, validateField } = form;

  useEffect(() => {
    Object.keys(errors).forEach((fieldName) => {
      setFieldTouched(fieldName);
      validateField(fieldName);
    });
  }, [i18n.language]);
};
